import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import classnames from 'classnames';

import styles from './Spinner.scss';

function Spinner(props) {
  const { overlay, className, size, ...restProps } = props;
  const progress = (
    <CircularProgress
      size={size}
      className={classnames(styles.loader, className)}
      {...restProps}
    />
  );

  return overlay ? <div className={styles.overlay}>{progress}</div> : progress;
}

Spinner.propTypes = {
  overlay: PropTypes.bool,
  className: PropTypes.string,
  size: PropTypes.number,
};

Spinner.defaultProps = {
  overlay: false,
  size: 50,
  className: null,
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/controls/Spinner.jsx